module.exports = __webpack_public_path__ + "static/media/aLackOfClarity.9c11ebfe.webp";